import mergeWith from 'lodash/mergeWith';

export const mergeDefaults = (defaults, data) =>
  mergeWith({}, defaults, data, (defaultValue, value) => value ?? defaultValue);

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
